export const projects = [
    {
        title: 'Brians Eclipse',
        slug: 'brianseclipse',
        date: 'May 2021',
        tags: [],
        thumbnail: '/projects/2021/brianseclipse/brianseclipse-thumb.webp',
        content: `<img src="/projects/2021/brianseclipse/brianseclipse.webp" width="1920" height="1080">`
    },
    {
        title: 'Midnight Purple',
        slug: 'midnighpurple',
        date: 'May 2021',
        tags: [],
        thumbnail: '/projects/2021/midnighpurple/midnighpurple-thumb.webp',
        content: `<img src="/projects/2021/midnighpurple/midnighpurple.webp" width="1920" height="1080">`
    },
    {
        title: 'White Eclipse',
        slug: 'whiteeclipse',
        date: 'May 2021',
        tags: [],
        thumbnail: '/projects/2021/whiteeclipse/whiteeclipse-thumb.webp',
        content: `<img src="/projects/2021/whiteeclipse/whiteeclipse.webp" width="1920" height="1080">`
    },
	{
        title: 'Grey 22B',
        slug: 'grey22b',
        date: 'April 2021',
        tags: [],
        thumbnail: '/projects/2021/grey22b/grey22b-thumb.jpg',
        content: `<img src="/projects/2021/grey22b/grey22b.jpg" width="1600" height="900">`
    },
    {
        title: 'Classic 22B',
        slug: 'classic22b',
        date: 'April 2021',
        tags: [],
        thumbnail: '/projects/2021/classic22b/classic22b-thumb.jpg',
        content: `<img src="/projects/2021/classic22b/classic22b.jpg" width="1600" height="900">`
    },
    {
        title: 'That Subaru',
        slug: 'that-subaru',
        date: 'April 2021',
        tags: [],
        thumbnail: '/projects/2021/thatsubaru/thatsubaru-thumb.jpg',
        content: `<img src="/projects/2021/thatsubaru/thatsubaru.jpg" width="1600" height="900">`
    },
    {
        title: 'Mr. Gray Evo',
        slug: 'mr-gray-evo',
        date: 'March 2021',
        tags: [],
        thumbnail: '/projects/2021/mrgrayevo/mrgrayevo-thumb.jpg',
        content: `
        <img src="/projects/2021/mrgrayevo/mrgrayevo.jpg" width="1280" height="1600">
        `
    },
    {
        title: 'Midnight Stroll',
        slug: 'midnight-stroll',
        date: 'March 2021',
        tags: [],
        thumbnail: '/projects/2021/midnightstroll/midnightstroll-thumb.jpg',
        content: `
        <img src="/projects/2021/midnightstroll/midnightstroll.jpg" width="1280" height="1600">
        `
    },
    {
        title: 'That Red Evo',
        slug: 'that-red-evo',
        date: 'March 2021',
        tags: [],
        thumbnail: '/projects/2021/thatredevo/thatredevo-thumb.jpg',
        content: `
        <img src="/projects/2021/thatredevo/thatredevo.jpg" width="1280" height="1600">
        `
    },
    {
        title: 'Blue Pandem',
        slug: 'bluepandem',
        date: 'Feb 2021',
        tags: [],
        thumbnail: '/projects/2021/bluepandem/bluepandem-thumb.jpg',
        content: `
        <img src="/projects/2021/bluepandem/bluepandem.webp" width="1280" height="1599">
        `
    },
    {
        title: 'That Red EG',
        slug: 'thatredeg',
        date: 'Feb 2021',
        tags: [],
        thumbnail: '/projects/2021/thatredeg/thatredeg-thumb.jpg',
        content: `
        <img src="/projects/2021/thatredeg/thatredeg.webp" width="1280" height="1599">
        `
    },
    {
        title: 'Night Stroll',
        slug: 'nightstroll',
        date: 'August 2020',
        tags: [],
        thumbnail: '/projects/2020/nightstroll/nightstroll-thumb.jpg',
        content: `
        <img src="/projects/2020/nightstroll/nightstroll.jpg" width="1228" height="1534">
        `
    },
    {
        title: 'RX Punk',
        slug: 'rxpunk',
        date: 'August 2020',
        tags: ['icon-images'],
        thumbnail: '/projects/2020/rxpunk/rxpunk-thumb.jpg',
        content: `
        <img src="/projects/2020/rxpunk/rxpunk-1.jpg" width="1600" height="2000">
        <img src="/projects/2020/rxpunk/rxpunk-2.jpg" width="1206" height="1507">
        `
    },
    {
        title: 'RX Drift',
        slug: 'rxdrift',
        date: 'August 2020',
        tags: ['icon-images'],
        thumbnail: '/projects/2020/rxdrift/rxdrift-thumb.jpg',
        content: `
        <img src="/projects/2020/rxdrift/rxdrift-1.jpg" width="1600" height="2000">
        <img src="/projects/2020/rxdrift/rxdrift-2.jpg" width="1206" height="1507">
        `
    },
    {
        title: 'Silver Dark NSX',
        slug: 'silverdarknsx',
        date: 'March 2020',
        tags: ['icon-motion','icon-images'],
        thumbnail: '/projects/2020/silverdarknsx/silverdarknsx-thumb.jpg',
        content: `
        <div class="iframe-wrap"><iframe width="1196" height="673" src="https://www.youtube.com/embed/xW6Jnk-CMSE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
        <img src="/projects/2020/silverdarknsx/silverdarknsx-1.jpg" width="2000" height="1600">
        <img src="/projects/2020/silverdarknsx/silverdarknsx-2.jpg" width="2000" height="1600">
        <img src="/projects/2020/silverdarknsx/silverdarknsx-3.jpg" width="2000" height="1600">
        `
    },
    {
        title: 'Speed Maniac',
        slug: 'speed-maniac',
        date: 'August 2019',
        tags: ['icon-motion', 'icon-images'],
        thumbnail: '/projects/2019/speedmaniac/speedmaniac-thumb.jpg',
        content: `
        <div class="iframe-wrap"><iframe width="1196" height="673" src="https://www.youtube.com/embed/YwYMwHP-u24" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
        <img src="/projects/2019/speedmaniac/speedmaniac.jpg" width="1280" height="1600">
        `
    },
    {
        title: 'Green Evo',
        slug: 'green-evo',
        date: 'May 2019',
        tags: ['icon-motion','icon-images'],
        thumbnail: '/projects/2019/greenevo/greenevo-thumb.jpg',
        content: `
        <div class="iframe-wrap"><iframe width="1196" height="673" src="https://www.youtube.com/embed/S7XCEfg7tnY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
        <img src="/projects/2019/greenevo/greenevo-1.png" width="956" height="956">
        <img src="/projects/2019/greenevo/greenevo-2.jpg" width="1280" height="1280">
        `
    },
    {
        title: 'Wide Integra',
        slug: 'wide-integra',
        date: 'August 2019',
        tags: [],
        thumbnail: '/projects/2019/wideintegra/wideintegra-thumb.jpg',
        content: `<img src="/projects/2019/wideintegra/wideintegra.jpg" width="1280" height="1600">`
    },
    {
        title: 'Neon GSR',
        slug: 'neon-gsr',
        date: 'July 2019',
        tags: [],
        thumbnail: '/projects/2019/neongsr/neongsr-thumb.jpg',
        content: `<img src="/projects/2019/neongsr/neongsr.jpg" width="1280" height="1600">`
    },
    {
        title: 'Road Trip',
        slug: 'road-trip',
        date: 'July 2019',
        tags: [],
        thumbnail: '/projects/2019/roadtrip/roadtrip-thumb.jpg',
        content: `<img src="/projects/2019/roadtrip/roadtrip.jpg" width="1280" height="1600">`
    },
    {
        title: 'Cyberpunk Evo',
        slug: 'cyberpunk-evo',
        date: 'July 2019',
        tags: [],
        thumbnail: '/projects/2019/cyberpunkevo/cyberpunkevo-thumb.jpg',
        content: `<img src="/projects/2019/cyberpunkevo/cyberpunkevo.jpg" width="1600" height="1600">`
    },
    
    {
        title: 'Shiny Evo',
        slug: 'shiny-evo',
        date: 'July 2019',
        tags: [],
        thumbnail: '/projects/2019/shinyevo/shinyevo-thumb.jpg',
        content: `<img src="/projects/2019/shinyevo/shinyevo.jpg" width="1600" height="1600">`
    },
    {
        title: 'Chinatown Evo',
        slug: 'chinatown-evo',
        date: 'July 2019',
        tags: [],
        thumbnail: '/projects/2019/chinatownevo/chinatownevo-thumb.jpg',
        content: `<img src="/projects/2019/chinatownevo/chinatownevo.jpg" width="1000" height="1000">`
    },
    {
        title: 'The Blue Evo',
        slug: 'the-blue-evo',
        date: 'July 2019',
        tags: [],
        thumbnail: '/projects/2019/blueevo/blueevo-thumb.jpg',
        content: `<img src="/projects/2019/blueevo/blueevo.jpg" width="980" height="1224">`
    },
    {
        title: 'Delage',
        slug: 'delage',
        date: 'July 2019',
        tags: [],
        thumbnail: '/projects/2019/delage/delage-thumb.jpg',
        content: `<img src="/projects/2019/delage/delage.jpg" width="1130" height="1412">`
    },
    {
        title: 'Drive By',
        slug: 'drive-by',
        date: 'July 2019',
        tags: [],
        thumbnail: '/projects/2019/driveby/driveby-thumb.jpg',
        content: `<img src="/projects/2019/driveby/driveby.jpg" width="1280" height="1600">`
    },
    {
        title: 'That Supra',
        slug: 'that-supra',
        date: 'July 2019',
        tags: [],
        thumbnail: '/projects/2019/thatsupra/thatsupra-thumb.jpg',
        content: `<img src="/projects/2019/thatsupra/thatsupra.jpg" width="1246" height="1560">`
    },
    {
        title: 'Blue Supra',
        slug: 'blue-supra',
        date: 'July 2019',
        tags: [],
        thumbnail: '/projects/2019/bluesupra/bluesupra-thumb.jpg',
        content: `<img src="/projects/2019/bluesupra/bluesupra.jpg" width="1280" height="1600">`
    },
    {
        title: 'Obscure',
        slug: 'obscure',
        date: 'July 2019',
        tags: ['icon-motion','icon-images'],
        thumbnail: '/projects/2019/obscure/obscure-thumb.jpg',
        content: `
        <div class="iframe-wrap"><iframe width="1196" height="673" src="https://www.youtube.com/embed/rVDLTEexbfo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
        <img src="/projects/2019/obscure/obscure.jpg" width="1080" height="1350">
        `
    },
    {
        title: 'The Room',
        slug: 'the-room',
        date: 'July 2019',
        tags: ['icon-motion','icon-images'],
        thumbnail: '/projects/2019/theroom/theroom-thumb.jpg',
        content: `
        <div class="iframe-wrap"><iframe width="1196" height="673" src="https://www.youtube.com/embed/9AwXxvUaCaA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
        <img src="/projects/2019/theroom/theroom.jpg" width="829" height="1036">
        `
    },
    {
        title: 'Sunrise',
        slug: 'sunrise',
        date: 'July 2019',
        tags: ['icon-motion','icon-images'],
        thumbnail: '/projects/2019/sunrise/sunrise-thumb.jpg',
        content: `
        <div class="iframe-wrap"><iframe width="1196" height="673" src="https://www.youtube.com/embed/pVmUFEQlkwg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
        <img src="/projects/2019/sunrise/sunrise.jpg" width="1080" height="1350">
        `
    },
    {
        title: 'Night Life',
        slug: 'nightlife',
        date: 'July 2019',
        tags: [],
        thumbnail: '/projects/2019/nightlife/nightlife-thumb.jpg',
        content: `<img src="/projects/2019/nightlife/nightlife.jpg" width="800" height="1000">`
    },
    {
        title: 'GEARS',
        slug: 'gears',
        date: 'Dec 2019',
        tags: ['icon-motion', 'icon-images'],
        thumbnail: '/projects/2019/gears/gears-thumb.jpg',
        content: `
        <h1>Motion Design / Title Opener</h1>
        <p>Tools : Cinema 4D, Octane Render, Sony Vegas and After Effects.</p>
        <p>Modeling, texturing, lighting, and animation in Cinema 4D.</p>
        <p>Rendered using Octane Render.</br>
        Sound Design done in Sony Vegas.</br>
        Compositing in After Effects.</br>
        </p>
        <div class="iframe-wrap"><iframe title="GEARS - Title Opener" src="https://player.vimeo.com/video/345348719" width="500" height="281" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe></div>
        <h3>Animatic</h3>
        <div class="iframe-wrap"><iframe title="GEARS - Animatic" src="https://player.vimeo.com/video/345348200" width="426" height="240" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe></div>
        <p>Modelling, texturing, lighting and animation done in Cinema 4D</p>
        <h3>Sound Design</h3>
        <div class="iframe-wrap"><iframe title="GEARS - Sound Design" src="https://player.vimeo.com/video/345348115" width="500" height="281" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe></div>
        <p>Sound Design done in Sony Vegas Pro</p>
        <h3>Stills</h3>
        <img src="/projects/2019/gears/gears-1.jpg" width="960" height="540">
        <img src="/projects/2019/gears/gears-6.jpg" width="960" height="540">
        <img src="/projects/2019/gears/gears-5.jpg" width="960" height="540">
        <img src="/projects/2019/gears/gears-2.jpg" width="960" height="540">
        <img src="/projects/2019/gears/gears-3.jpg" width="960" height="540">
        <img src="/projects/2019/gears/gears-4.jpg" width="960" height="540">
        <img src="/projects/2019/gears/gears-7.jpg" width="960" height="540">
        <img src="/projects/2019/gears/gears-8.jpg" width="960" height="540">
        <img src="/projects/2019/gears/gears-9.jpg" width="960" height="540">
        `
    },
    {
        title: 'Eglaf',
        slug: 'eglaf',
        date: 'Sept 2017',
        tags: ['icon-motion'],
        thumbnail: '/projects/2017/eglaf/eglaf-thumb.jpg',
        content: `<div class="iframe-wrap"><iframe width="910" height="510" src="https://www.youtube.com/embed/A8b13SymeCM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`
    },
    {
        title: 'Chada Valencia',
        slug: 'chada-valencia',
        date: 'July 2017',
        tags: ['icon-images'],
        thumbnail: '/projects/2019/chadavalencia/chadavalencia-thumb.jpg',
        content: `
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-01.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-02.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-03.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-04.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-05.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-06.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-07.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-08.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-09.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-10.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-11.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-12.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-13.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-14.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-15.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-16.jpg" width="1280" height="1280">
        <img src="/projects/2019/chadavalencia/grantimbo-chada-valencia-17.jpg" width="1559" height="1103">
        `
    },
    {
        title: 'Dumzville',
        slug: 'dumzville',
        date: 'March 2017',
        tags: ['icon-images'],
        thumbnail: '/projects/2017/dumzville/dumzville-thumb.jpg',
        content: `
        <img src="/projects/2017/dumzville/dumzville-1.jpg" width="1140" height="737">
        <img src="/projects/2017/dumzville/dumzville-2.jpg" width="833" height="833">
        <img src="/projects/2017/dumzville/dumzville-3.jpg" width="833" height="833">
        <img src="/projects/2017/dumzville/dumzville-4.jpg" width="1000" height="833">
        <img src="/projects/2017/dumzville/dumzville-5.jpg" width="1000" height="833">
        <img src="/projects/2017/dumzville/dumzville-6.jpg" width="1000" height="833">
        `
    },
    {
        title: 'S Type',
        slug: 's-type',
        date: 'July 2017',
        tags: ['icon-images'],
        thumbnail: '/projects/2017/stype/s-type-thumb.jpg',
        content: `
        <img src="/projects/2017/stype/s-type-1.jpg" width="800" height="800">
        <img src="/projects/2017/stype/s-type-2.jpg" width="800" height="800">
        `
    },
    {
        title: 'Metabol',
        slug: 'metabol',
        date: 'March 2016',
        tags: ['abstract-art'],
        thumbnail: '/projects/2016/abstractrenders/metabol-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/metabol.jpg" width="900" height="1125"> `
    },
    {
        title: 'Pinktree',
        slug: 'pinktree',
        date: 'March 2016',
        tags: ['abstract-art'],
        thumbnail: '/projects/2016/abstractrenders/pinktree-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/pinktree.jpg" width="900" height="1125"> `
    },
    {
        title: 'splash',
        slug: 'splash',
        date: 'March 2016',
        tags: ['abstract'],
        thumbnail: '/projects/2016/abstractrenders/splash-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/splash.jpg" width="1000" height="1000"> `
    },
    {
        title: 'rotate',
        slug: 'rotate',
        date: 'March 2016',
        tags: ['abstract'],
        thumbnail: '/projects/2016/abstractrenders/rotate-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/rotate.jpg" width="1000" height="1000"> `
    },
    {
        title: 'ripple',
        slug: 'ripple',
        date: 'March 2016',
        tags: ['abstract'],
        thumbnail: '/projects/2016/abstractrenders/ripple-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/ripple.jpg" width="1000" height="1000"> `
    },
    {
        title: 'pointcube',
        slug: 'pointcube',
        date: 'March 2016',
        tags: ['abstract-art'],
        thumbnail: '/projects/2016/abstractrenders/pointcube-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/pointcube.jpg" width="1000" height="1000"> `
    },
    {
        title: 'orba',
        slug: 'orba',
        date: 'March 2016',
        tags: ['abstract-art'],
        thumbnail: '/projects/2016/abstractrenders/orba-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/orba.jpg" width="1000" height="1000"> `
    },
    {
        title: 'infiniteswirl',
        slug: 'infiniteswirl',
        date: 'March 2016',
        tags: ['abstract-art'],
        thumbnail: '/projects/2016/abstractrenders/infiniteswirl-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/infiniteswirl.jpg" width="1000" height="1000"> `
    },
    {
        title: 'eww',
        slug: 'eww',
        date: 'March 2016',
        tags: ['abstract-art'],
        thumbnail: '/projects/2016/abstractrenders/eww-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/eww.jpg" width="1000" height="1000"> `
    },
    {
        title: 'cylinswirl',
        slug: 'cylinswirl',
        date: 'March 2016',
        tags: ['abstract-art'],
        thumbnail: '/projects/2016/abstractrenders/cylinswirl-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/cylinswirl.jpg" width="1000" height="1000"> `
    },
    {
        title: 'cubi',
        slug: 'cubi',
        date: 'March 2016',
        tags: ['abstract-art'],
        thumbnail: '/projects/2016/abstractrenders/cubi-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/cubi.jpg" width="1000" height="1000"> `
    },
    {
        title: 'bubbles',
        slug: 'bubbles',
        date: 'March 2016',
        tags: ['abstract-art'],
        thumbnail: '/projects/2016/abstractrenders/bubbles-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/bubbles.jpg" width="1000" height="1000"> `
    },
    {
        title: 'tuby',
        slug: 'tuby',
        date: 'March 2016',
        tags: ['abstract-art'],
        thumbnail: '/projects/2016/abstractrenders/tuby-thumb.jpg',
        content: `<img src="/projects/2016/abstractrenders/tuby.jpg" width="1000" height="1000"> `
    },
    {
        title: 'Do it Now',
        slug: 'do-it-now',
        date: 'July 2015',
        tags: ['icon-images'],
        thumbnail: '/projects/2015/doitnow/do-it-now-thumb.jpg',
        content: `
        <img src="/projects/2015/doitnow/doitnow-1.jpg" width="560" height="750">
        <img src="/projects/2015/doitnow/doitnow-2.jpg" width="560" height="750">
        `
    },
    {
        title: 'Slanttex',
        slug: 'slanntex',
        date: 'September 2014',
        tags: ['icon-code'],
        thumbnail: '/projects/2014/slanttex/slanttex-thumb.jpg',
        content: `
        <p>Demo : <a href="https://grantimbo.github.io/slanttex/">https://grantimbo.github.io/slanttex/</a></p>
        <p>Repo :  <a href="https://github.com/grantimbo/slanttex">https://github.com/grantimbo/slanttex</a> </p>
        <img src="/projects/2014/slanttex/slanttex-1.png" width="918" height="505">
        <img src="/projects/2014/slanttex/slanttex-2.png" width="915" height="542">
        <img src="/projects/2014/slanttex/slanttex-3.png" width="910" height="503">
        <img src="/projects/2014/slanttex/slanttex-4.png" width="918" height="505">
        `
    },
    {
        title: 'Life Goes On',
        slug: 'life-goes-on',
        date: 'October 2014',
        tags: [],
        thumbnail: '/projects/2014/lifegoeson/lifegoeson-thumb.jpg',
        content: `<img src="/projects/2014/lifegoeson/lifegoeson.jpg" width="1336" height="1764">`
    },
    {
        title: 'Feel that Sweetness',
        slug: 'feel-that-sweetness',
        date: 'September 2014',
        tags: ['icon-motion'],
        thumbnail: '/projects/2014/feelthatsweetness/feelthatsweetness-thumb.jpg',
        content: `<div class="iframe-wrap"><iframe width="910" height="510" src="https://www.youtube.com/embed/uXwCt_LfeLs" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`
    },
    {
        title: 'Type G',
        slug: 'type-g',
        date: 'September 2014',
        tags: [],
        thumbnail: '/projects/2014/typeg/typeg-thumb.jpg',
        content: `<img src="/projects/2014/typeg/typeg.jpg" width="750" height="1836">`
    },
    {
        title: 'Summer Time',
        slug: 'summer-time',
        date: 'April 2014',
        tags: [],
        thumbnail: '/projects/2014/summertime/summertime-thumb.jpg',
        content: `<img src="/projects/2014/summertime/summertime.jpg" width="1134" height="596">`
    },
    {
        title: 'Neon Life',
        slug: 'neon-life',
        date: 'April 2014',
        tags: ['icon-images'],
        thumbnail: '/projects/2014/neonlife/neonlife-thumb.jpg',
        content: `
        <img src="/projects/2014/neonlife/neonlife-1.jpg" width="1466" height="877">
        <img src="/projects/2014/neonlife/neonlife-2.jpg" width="1466" height="877">
        <img src="/projects/2014/neonlife/neonlife-3.jpg" width="1466" height="877">
        `
    },
    {
        title: 'Keep Calm',
        slug: 'keep-calm',
        date: 'October 2013',
        tags: ['icon-images'],
        thumbnail: '/projects/2013/keepcalm/keepcalm-thumb.jpg',
        content: `
        <img src="/projects/2013/keepcalm/keepcalm-1.jpg" width="1920" height="1200">
        <img src="/projects/2013/keepcalm/keepcalm-2.jpg" width="1920" height="1200">
        <img src="/projects/2013/keepcalm/keepcalm-3.jpg" width="1920" height="1200">
        `
    },
    {
        title: 'Discipline',
        slug: 'discipline',
        date: 'July 2013',
        tags: ['icon-images'],
        thumbnail: '/projects/2013/discipline/discipline-thumb.jpg',
        content: `<img src="/projects/2013/discipline/discipline.jpg" width="1000" height="2007">`
    },
    {
        title: 'Type Compilation',
        slug: 'type-compilation',
        date: '2011-2013',
        tags: ['icon-images'],
        thumbnail: '/projects/2012/typecompilation/type-compilation-thumb.jpg',
        content: `
        <img src="/projects/2012/typecompilation/typecomp-1.jpg">
        <img src="/projects/2012/typecompilation/typecomp-2.jpg">
        <img src="/projects/2012/typecompilation/typecomp-3.jpg">
        <img src="/projects/2012/typecompilation/typecomp-4.jpg">
        <img src="/projects/2012/typecompilation/typecomp-5.jpg">
        <img src="/projects/2012/typecompilation/typecomp-6.jpg">
        <img src="/projects/2012/typecompilation/typecomp-7.jpg">
        <img src="/projects/2012/typecompilation/typecomp-8.jpg">
        <img src="/projects/2012/typecompilation/typecomp-9.jpg">
        <img src="/projects/2012/typecompilation/typecomp-10.jpg">
        <img src="/projects/2012/typecompilation/typecomp-11.jpg">
        <img src="/projects/2012/typecompilation/typecomp-12.jpg">
        <img src="/projects/2012/typecompilation/typecomp-13.jpg">
        <img src="/projects/2012/typecompilation/typecomp-14.jpg">
        <img src="/projects/2012/typecompilation/typecomp-15.jpg">
        <img src="/projects/2012/typecompilation/typecomp-16.jpg">
        <img src="/projects/2012/typecompilation/typecomp-17.jpg">
        <img src="/projects/2012/typecompilation/typecomp-18.jpg">
        <img src="/projects/2012/typecompilation/typecomp-19.jpg">
        <img src="/projects/2012/typecompilation/typecomp-20.jpg">
        <img src="/projects/2012/typecompilation/typecomp-21.jpg">
        <img src="/projects/2012/typecompilation/typecomp-22.jpg">
        `
    },
    {
        title: 'The Epic',
        slug: 'the-epic',
        date: 'November 2012',
        tags: ['icon-motion'],
        thumbnail: '/projects/2012/theepic/theepic-thumb.jpg',
        content: `<div class="iframe-wrap"><iframe width="910" height="510" src="https://www.youtube.com/embed/dedLQtYjjvs" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`
    },
    {
        title: 'Under',
        slug: 'under',
        date: 'November 2012',
        tags: ['icon-motion'],
        thumbnail: '/projects/2012/under/under-thumb.jpg',
        content: `<div class="iframe-wrap"><iframe width="910" height="510" src="https://www.youtube.com/embed/OaUAG2J2hDQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`
    },
    {
        title: 'Lost in War',
        slug: 'lost-in-war',
        date: 'November 2012',
        tags: ['icon-motion'],
        thumbnail: '/projects/2012/lostinwar/lostinwar-thumb.jpg',
        content: `<div class="iframe-wrap"><iframe width="910" height="510" src="https://www.youtube.com/embed/M1LkLZ7fjeg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`
    },

]